var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',_vm._b({attrs:{"background":"","layout":_vm.layout,"page-sizes":_vm.pageSizes,"page-size":_vm.size,"pager-count":_vm.pagerCount},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}},'el-pagination',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }